import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesResponse } from '../../../services/file.service';
import { PostFeaturedComponent } from '../post-featured/post-featured.component';
import { BreadcrumbScope } from '../breadcrumb/breadcrumb.component';

type ViewportSize = 'phone' | 'tablet' | 'laptop' | 'desktop';

@Component({
  selector: 'app-post-drawer',
  standalone: true,
  imports: [CommonModule, PostFeaturedComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="drawer" *ngIf="open" [attr.data-size]="viewportSize" role="dialog" aria-modal="true" [attr.aria-label]="bundle?.topic ?? 'Post detail'">
      <button type="button" class="drawer__backdrop" (click)="close.emit()" aria-label="Close"></button>
      <aside class="drawer__panel" #panel tabindex="-1">
        <div class="drawer__topbar">
          <button type="button" class="drawer__closeBtn" (click)="close.emit()" aria-label="Close drawer">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </div>
        <div class="drawer__body">
          <app-post-featured *ngIf="bundle"
            [bundle]="bundle"
            [lang]="lang"
            [viewportSize]="viewportSize"
            density="compact"
            [collapsible]="false"
            (crumbNavigate)="crumbNavigate.emit($event)"
            (langChange)="langChange.emit($event)">
          </app-post-featured>
        </div>
      </aside>
    </div>
  `,
  styleUrls: ['./post-drawer.component.css'],
})
export class PostDrawerComponent implements OnChanges, AfterViewChecked {
  @Input() bundle: FilesResponse | null = null;
  @Input() open = false;
  @Input() lang: 'en' | 'hi' = 'en';
  @Input() viewportSize: ViewportSize = 'laptop';
  @Output() close = new EventEmitter<void>();
  @Output() crumbNavigate = new EventEmitter<{ scope: BreadcrumbScope; bundle: FilesResponse }>();
  @Output() langChange = new EventEmitter<{ bundleId: number; lang: 'en' | 'hi' }>();

  @ViewChild('panel') panel?: ElementRef<HTMLElement>;
  private didFocus = false;

  ngOnChanges(): void {
    this.didFocus = false;
    if (this.open && typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    } else if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  }

  ngAfterViewChecked(): void {
    if (this.open && this.panel && !this.didFocus) {
      this.panel.nativeElement.focus({ preventScroll: true });
      this.didFocus = true;
    }
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    if (this.open) this.close.emit();
  }
}
